<span id="{{config['id']}}" attr.data-html="{{config['html']}}" attr.data-bs-toggle="{{config['dataToggle']}}" attr.data-trigger="{{config['dataTrigger']}}" attr.data-placement="{{config['dataPlacement']}}">
  <i class="fa fa-info-circle" aria-hidden="true"></i>
</span>